import "./GameCard.css";
import { Link } from 'react-router-dom';

export default function GameCard({ game }) {
  const isLaunched = game.isLaunched === true || game.isLaunched === "true";

  const offsetX = game.coverOffset?.position?.x || 0;
  const offsetY = game.coverOffset?.position?.y || 0;
  const scaleX = game.coverOffset?.scale?.x || 1;
  const scaleY = game.coverOffset?.scale?.y || 1;

  return (
    <div className="game-card">
      
      {/* COVER */}
      <div className="game-cover">
        <img
          src={game.cover}
          alt={game.title}
          style={{
            transform: `translate(${offsetX}px, ${offsetY}px) scale(${scaleX}, ${scaleY})`
          }}
        />
      </div>

      {/* ... resto do componente permanece igual ... */}
      <div className="game-content">
        <h2>{game.title}</h2>
        <p>{game.description}</p>

        <div className="game-tags">
          {game.tags?.map((tag, index) => (
            <span key={index}>{tag}</span>
          ))}
        </div>

        <div className="game-gallery">
          {game.gallery?.map((img, index) => (
            <img key={index} src={img} alt="preview" />
          ))}
        </div>

        <div className="game-info">
          <div>
            <span>Lançamento</span>
            <strong>{game.releaseDate}</strong>
          </div>
          <div>
            <span>Desenvolvedor</span>
            <strong>{game.developer}</strong>
          </div>
          <div>
            <span>Distribuidora</span>
            <strong>{game.publisher}</strong>
          </div>
        </div>

        <div className="game-actions">
          {isLaunched ? (
            <Link to={game.playUrl} className="btn primary">
              Jogar
            </Link>
          ) : (
            <button className="btn disabled" disabled>
              Jogar (em breve)
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
